import React from 'react'
import { connect } from 'react-redux'
import { RepoClassification, OpenRepoOrderTerms, FixedRepoOrderTerms } from 'api'
import { Field } from 'view/components/inputs'
import { Selectbox } from 'view/components/options'
import { createStructuredSelector } from 'reselect'
import { OrderTermHelper } from 'model'
import { TermSelectboxProps } from './TermSelectbox'

interface FilteredTermSelectboxProps extends TermSelectboxProps {
  repoClassification?: RepoClassification
}

const filteredTermMapStateToProps = createStructuredSelector({
  optionKeys: (_: {}, props: FilteredTermSelectboxProps): String[] =>
    props.repoClassification === RepoClassification.OPEN || props.repoClassification === RepoClassification.OPEN_EVERGREEN
      ? OpenRepoOrderTerms
      : FixedRepoOrderTerms
})

export const FilteredTermSelectbox = connect(filteredTermMapStateToProps, null, null, { forwardRef: true })(
  Selectbox as React.ComponentType<FilteredTermSelectboxProps>
)

FilteredTermSelectbox.defaultProps = {
  getOptionText: OrderTermHelper.getName
}

export const FilteredTermSelectboxField = Field(FilteredTermSelectbox)
